import api from "../lib/api";

export type EnvService = "backend" | "video-backend" | "stream-backend";

export const saveEnvConfig = (payload: {
  service: EnvService;
  key: string;
  value: string;
  isSecret: boolean;
}) => api.post("/api/admin/env-config/save", payload);

export const importEnvConfig = (payload: {
  service: EnvService;
  content: string;
}) => api.post("/api/admin/env-config/import", payload);

export const revealEnvConfig = (payload: { service: EnvService; key: string }) =>
  api.post("/api/admin/env-config/reveal", payload);

export const deleteEnvConfig = (payload: { service: EnvService; key: string }) =>
  api.post("/api/admin/env-config/delete", payload);
